import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/browser';
import App from './App';
import './main.css';
import { isPlatform } from './utilities/platform';
import { DEVICE, ENABLE_SENTRY, PRODUCTION, SENTRY_DSN } from './config';

import './i18n';

const container = document.getElementById('root');
const root = createRoot(container!);

// Initialize Sentry only if ENABLE_SENTRY is true
if (ENABLE_SENTRY) {
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: PRODUCTION ? 'production' : 'development',
        integrations: [
            browserTracingIntegration({
                tracePropagationTargets: [
                    'localhost',
                    'https://appv1.stimulin.fr',
                    'http://localhost:8080'
                ]
            }),
            Sentry.replayIntegration()
        ],
        // Adjust sampling rates based on environment
        tracesSampleRate: PRODUCTION ? 0.2 : 1.0, // 20% in prod, 100% in dev
        replaysSessionSampleRate: PRODUCTION ? 0.1 : 1.0, // 10% in prod, 100% in dev
        replaysOnErrorSampleRate: 1.0, // Always capture replays on error

        // Add tags to identify the platform
        initialScope: {
            tags: {
                platform: DEVICE, // ANDROID, IOS, PWA, WEB, SW
                is_hybrid: isPlatform('hybrid') // true for iOS/Android, false for web
            }
        },

        // Before sending an event, enrich the data
        beforeSend(event) {
            // Add additional contexts
            event.contexts = {
                ...event.contexts,
                device: {
                    type: DEVICE,
                    is_mobile: isPlatform('mobile'),
                    is_desktop: isPlatform('desktop'),
                    is_pwa: DEVICE === 'PWA'
                }
            };
            return event;
        }
    });
    console.log(
        'Sentry initialized:',
        PRODUCTION ? 'production' : 'development',
        'Platform:',
        DEVICE
    );
} else {
    console.log('Sentry disabled (local development).');
}

console.log('DEVICE', DEVICE);

document.documentElement.classList.add(DEVICE.toLowerCase());

root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
);
